import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text, Box } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const CustomIndustriesEmptyState = () => {
    const t = useTranslation();

    const navigateToMarketBuilder = () => {
        proNavigator.go("market_research_builder", {
            returnToState: "digitalsuite_marketresearch_webmarketanalysis_mapping",
        });
    };

    return (
        <Box padding="8px">
            <Flex
                flexDirection="column"
                padding="16px"
                gap="16px"
                background={colorsPalettes.sky[100]}
            >
                <Flex
                    flexDirection="column"
                    gap="8px"
                >
                    <Text fontVariant="subtitle2">{t("autocomplete.market.tab.custom.section.create.cta.title")}</Text>
                    <Text fontVariant="input2">{t("autocomplete.market.tab.custom.section.create.cta.subtitle")}</Text>
                </Flex>
                <Flex justifyContent="flex-end">
                    <IconButton
                        type="primary"
                        iconName="add"
                        onClick={navigateToMarketBuilder}
                    >
                        {t("autocomplete.market.tab.custom.section.create.cta.title")}
                    </IconButton>
                </Flex>
            </Flex>
        </Box>
    );
};

export const SharedIndustriesEmptyState = () => {
    const t = useTranslation();

    return (
        <Box padding="14px">
            <Text fontVariant="listItem4">{t("autocomplete.market.tab.shared.section.empty.title")}</Text>
        </Box>
    );
};
